import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <span>Lee Tae Ho (ANDY LEE)</span>
          </div>
          <div className="footer-links">
            <a href="https://github.com/andy3400" className="footer-link">GitHub</a>
            <a href="https://velog.io/@andy3400" className="footer-link">Blog</a>
            <a href="https://linkedin.com/in/taehogu/" className="footer-link">LinkedIn</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Andy. All rights reserved. {currentYear}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;